
import React, { useState } from 'react';
import Tectaks from './Tectaks';
import Newprogram from './Newprogram';
import Thirdactiveprogram from './Thirdactiveprogram';
import Advertisment from './Advertisment';

const MainComponent = () => {
  const [active, setActive] = useState('two');

  const wrapperStyle = {
    maxHeight: '750px', // Set the scrollable area height as needed
    overflowY: 'auto',
    scrollbarWidth: "none",
      msOverflowStyle: "none",
    border: '1px solid #ccc',
    borderRadius: '10px',
    padding: '0',
    position: 'relative',
  };

  const containerStyle = {
    //  padding: '0px 20px 30px 20px',
    fontFamily: 'sans-serif',
    backgroundColor:"blue"
  };

  const buttonRowStyle = {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: '10px',
    padding: '20px',
    background: 'blue',
    position: 'sticky',
    top: 82,
    zIndex: 10,
    // borderBottom: '1px solid #ddd',
  };

  const buttonStyle = (isActive) => ({
    padding: '10px 20px',
    border: 'none',
    borderRadius: '30px',
    backgroundColor: isActive ? 'orange' : '#e0e0e0',
    color: isActive ? '#fff' : '#000',
    fontWeight: 'bold',
    cursor: 'pointer',
    transition: '0.3s',
    minWidth: '100px',
  });

  const boxStyle = {
    // padding: '63px',
    // margin: '20px auto',
    // maxWidth: '1260px',
    textAlign: 'left',
    boxSizing: 'border-box',
    marginTop: '70px',
  };

  const activeBoxStyle = {
    ...boxStyle,
    borderColor: '#007bff',
  };

  const renderComponent = () => {


    
    switch (active) {
      // case 'one':
      //   return (
      //     <div style={boxStyle}>
      //       <Tectaks />
            
      //     </div>
      //   );
      case 'two':
        return (
          <div style={activeBoxStyle}>
            
           <Newprogram/>
          </div>
        );
      // case 'three':
      //   return (
      //     <div style={boxStyle}>
      //       <Thirdactiveprogram/>
      //     </div>
      //   );
      // case 'four':
      //   return (
      //     <div style={boxStyle}>
      //       <h3>Filter 4</h3>
      //       <p>This is the fourth filter content.</p>
      //     </div>
      //   );
      // default:
        return null;
    }
  };

  return (
    <div style={wrapperStyle}>
      <div style={containerStyle}>
        <div style={buttonRowStyle}>
          {/* <button
            style={buttonStyle(active === 'one')}
            onClick={() => setActive('one')}
          >
           TecTalks
          </button> */}
          {/* <button
            style={buttonStyle(active === 'two')}
            onClick={() => setActive('two')}
          >
            programs
          </button> */}
          {/* <button
            style={buttonStyle(active === 'three')}
            onClick={() => setActive('three')}
          >
            Career Program
          </button> */}
          {/* <button
            style={buttonStyle(active === 'four')}
            onClick={() => setActive('four')}
          >
            WalkingDrive
          </button> */}
        </div>

        {/* Scrollable content */}
        {renderComponent()}

         {/* <Advertisment /> */}
      </div>

             <style>
         
       </style>
     
    </div>
  );
};

export default MainComponent;


